import React, { useMemo } from 'react';

import { formatDate } from 'lib/helpers/dateUtils';
import { Capitalize, iaRa, mString } from 'lib/helpers/utility';
import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';

import DocTable from 'components/shared/DocumentSheet/components/DocTable';
import DocSectionHead from 'components/shared/DocumentSheet/components/DocSectionHead';

const COLUMNS = [
  { key: 'date', label: 'Date', align: 'left', tabular: true },
  { key: 'method', label: 'Method', align: 'left' },
  { key: 'status', label: 'Status', align: 'left', strong: true },
  { key: 'amount', label: 'Amount', align: 'right', strong: true, tabular: true }
];

const PaymentHistory = ({ transactions, timezone }) => {
  const list = iaRa(transactions).filter((transaction) => transaction?.id);

  const groups = useMemo(
    () => [
      {
        key: 'payment-history',
        rows: list.map((transaction) => ({
          key: transaction.id,
          cells: [
            { value: formatDate(transaction.created_at, timezone, 'MM/dd/yyyy') },
            {
              value:
                (transaction.type
                  ? (TYPE_LABELS[transaction.type] ?? Capitalize(transaction.type))
                  : '') || '-'
            },
            { value: Capitalize(transaction.status) || '-' },
            { value: mString(transaction.amount_paid_self), align: 'right' }
          ]
        }))
      }
    ],
    [list, timezone]
  );

  if (!list.length) return null;

  return (
    <div>
      <DocSectionHead title="Payment history" />
      <DocTable columns={COLUMNS} groups={groups} headerPadClass="pb-[5px]" />
    </div>
  );
};

export default PaymentHistory;
